/**
 * Add Product to Recently Viewed Action
 * Triggered by: arc:action:recentlyViewedAdd
 */

import shopifyHelper from "../../js/shopify";

export const runRecentlyViewedAdd = async (data = {}) => {
    try {
        const { productId } = data;

        if (!productId) {
            throw new Error('Product ID is required');
        }

        // Get current recently viewed products from localStorage
        const existingProducts = JSON.parse(localStorage.getItem("recentlyviewed_products") || "[]");

        // Check if product already exists to avoid duplicates
        const isDuplicate = existingProducts.some(product => 
            parseInt(product.id) === parseInt(productId)
        );

        if (!isDuplicate) {
            // Fetch product data from Shopify
            const transformedProduct = await shopifyHelper.getShopifyProductList([productId]);
            
            if (transformedProduct && transformedProduct.length > 0) {
                // Add the new product to the beginning of the array
                const updatedProducts = [transformedProduct[0], ...existingProducts];
                
                // Limit to last 20 products to prevent unlimited growth
                const limitedProducts = updatedProducts.slice(0, 20);
                
                // Save to localStorage
                localStorage.setItem("recentlyviewed_products", JSON.stringify(limitedProducts));

                // Dispatch success event with the updated list
                window.dispatchEvent(new CustomEvent('recentlyViewed:updated', {
                    detail: {
                        products: limitedProducts,
                        addedProduct: transformedProduct[0]
                    }
                }));

                return {
                    success: true,
                    products: limitedProducts,
                    addedProduct: transformedProduct[0],
                    message: 'Product added to recently viewed'
                };
            } else {
                throw new Error('Failed to fetch product data');
            }
        } else {
            // Product already exists, just return the current list
            return {
                success: true,
                products: existingProducts,
                message: 'Product already in recently viewed list'
            };
        }

    } catch (error) {
        console.error('Recently Viewed Add error:', error);
        
        // Dispatch error event
        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'add'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

export default runRecentlyViewedAdd;
